// This icon file is generated automatically.
var PEditSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M13.13 7h-.88a.13.13 0 00-.13.13v5H1.88V1.87h5c.06 0 .12-.05.12-.12V.87a.13.13 0 00-.13-.12H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V7.12a.13.13 0 00-.13-.12z" } }, { "tag": "path", "attrs": { "d": "M4.56 7.36l-.03 1.86c0 .13.11.25.25.25l1.85-.05.09-.03 6.5-6.49a.13.13 0 000-.17L11.26.79a.13.13 0 00-.18 0L4.6 7.27a.13.13 0 00-.03.09zm1 .37l5.62-5.62.7.7-5.62 5.62-.72.02.01-.72z" } }] }] }, "name": "p-edit-square", "theme": "outlined" };
export default PEditSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PEditSquareOutlined.js
// module id = 3352
// module chunks = 0